var data = [
    {
      "street": "Trần Quang Khải",
      "ward": "Mỹ Thới",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.347252-105.459735",
      "radius": "22,50",
      "points": ""
    },
    {
      "street": "Hẻm Lê Lợi",
      "ward": "Mỹ Bình",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "29,05",
      "points": ""
    },
    {
      "street": "Đường cặp rạch Gòi Lớn",
      "ward": "Mỹ Thới",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "9,22",
      "points": ""
    },
    {
      "street": "Đường Thỏ Đế",
      "ward": "Bình Đức",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "7,00",
      "points": ""
    },
    {
      "street": "Hẻm Triệu Quang Phục",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "16,70",
      "points": ""
    },
    {
      "street": "Lê Văn Lương",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.362617-105.435246",
      "radius": "15,74",
      "points": ""
    },
    {
      "street": "Trần Văn Ơn",
      "ward": "Mỹ Thới",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.345594-105.464625",
      "radius": "9,14",
      "points": ""
    },
    {
      "street": "Hẻm Mỹ Lộc 1",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "13,41",
      "points": ""
    },
    {
      "street": "Hẻm Trần Hưng Đạo",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "12,62",
      "points": ""
    },
    {
      "street": "Hẻm Ung Văn Khiêm",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "26,56",
      "points": ""
    },
    {
      "street": "Đường số 10",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "21,20",
      "points": ""
    },
    {
      "street": "Hẻm Cô Giang",
      "ward": "Mỹ Bình",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.385901-105.432645",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Lê Hoàn",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.394412-105.414365",
      "radius": "13,43",
      "points": ""
    },
    {
      "street": "Hàm Nghi",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.393440-105.422020",
      "radius": "31,75",
      "points": ""
    },
    {
      "street": "Trần Quốc Tảng",
      "ward": "Đông Xuyên",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.374510-105.427114",
      "radius": "24,11",
      "points": ""
    },
    {
      "street": "Khu B4",
      "ward": "Đông Xuyên",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "14,47",
      "points": ""
    },
    {
      "street": "Hẻm Hà Hoàng Hổ- Mỹ Xuyên.",
      "ward": "Mỹ Xuyên",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Đường số 11",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.393003-105.414278",
      "radius": "19,38",
      "points": ""
    },
    {
      "street": "Lê Văn Hưu",
      "ward": "Mỹ Long",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.376621-105.441532",
      "radius": "68,57",
      "points": ""
    },
    {
      "street": "Trần Hưng Đạo",
      "ward": "Mỹ Quý",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.362673-105.451981",
      "radius": "31,53",
      "points": ""
    },
    {
      "street": "Nguyễn Văn Linh",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.367493-105.432326",
      "radius": "23,39",
      "points": ""
    },
    {
      "street": "Đường số 4",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "23,33",
      "points": ""
    },
    {
      "street": "Phạm Đình Hổ",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "12,50",
      "points": ""
    },
    {
      "street": "Đường số 2",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.368794-105.436878",
      "radius": "17,93",
      "points": ""
    },
    {
      "street": "Đường số 15",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Đường số 8",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.390433-105.417373",
      "radius": "23,28",
      "points": ""
    },
    {
      "street": "Hẻm cặp rạch Xẻo Chanh",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "11,61",
      "points": ""
    },
    {
      "street": "Đường số 9",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "21,75",
      "points": ""
    },
    {
      "street": "Tú Xương",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.395425-105.428582",
      "radius": "17,83",
      "points": ""
    },
    {
      "street": "Trường Chinh",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.363197-105.441037",
      "radius": "25,00",
      "points": ""
    },
    {
      "street": "Đường nhánh Võ Duy Dương",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "14,05",
      "points": ""
    },
    {
      "street": "DF12-TB",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "26,32",
      "points": ""
    },
    {
      "street": "Dự Định 3",
      "ward": "Mỹ Long",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "47,06",
      "points": ""
    },
    {
      "street": "Phạm Cự Lượng",
      "ward": "Mỹ Quý",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.362875-105.441123",
      "radius": "25,01",
      "points": ""
    },
    {
      "street": "Hà Hoàng Hổ",
      "ward": "Mỹ Xuyên",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.377887-105.432744",
      "radius": "67,52",
      "points": ""
    },
    {
      "street": "Nhánh Phan Đăng Lưu",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "16,43",
      "points": ""
    },
    {
      "street": "Đường số 18",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "28,42",
      "points": ""
    },
    {
      "street": "Đường số 1",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "11,39",
      "points": ""
    },
    {
      "street": "Tây An-Bờ Hồ",
      "ward": "Mỹ Thới",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "24,45",
      "points": ""
    },
    {
      "street": "Hẻm nhà thuốc Bá Tòng",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "32,47",
      "points": ""
    },
    {
      "street": "Trần Cảnh",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.371959-105.425017",
      "radius": "6,43",
      "points": ""
    },
    {
      "street": "Đường số 11",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "19,38",
      "points": ""
    },
    {
      "street": "Đường cặp Rạch Gòi Lớn",
      "ward": "Mỹ Thới",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "9,22",
      "points": ""
    },
    {
      "street": "đường số 1 Lê Hoàn",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "14,16",
      "points": ""
    },
    {
      "street": "Khu văn phòng đăng ký đất",
      "ward": "Mỹ Quý",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "11,12",
      "points": ""
    },
    {
      "street": "Dự Định 8",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Thục Phán",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.395012-105.416024",
      "radius": "17,80",
      "points": ""
    },
    {
      "street": "Hồ Hảo Hớn",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "46,67",
      "points": ""
    },
    {
      "street": "Phan Đăng Lưu",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.366061-105.441163",
      "radius": "22,32",
      "points": ""
    },
    {
      "street": "Hẻm Thoại Ngọc Hầu",
      "ward": "Mỹ Long",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "17,19",
      "points": ""
    },
    {
      "street": "Đường số 16",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "15,24",
      "points": ""
    },
    {
      "street": "Hẻm Phạm Cự Lượng",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "13,72",
      "points": ""
    },
    {
      "street": "Hẻm Lê Chân",
      "ward": "Mỹ Quý",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "15,35",
      "points": ""
    },
    {
      "street": "Đường Số 5",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "31,43",
      "points": ""
    },
    {
      "street": "Đặng Dung",
      "ward": "Mỹ Long",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.380183-105.443210",
      "radius": "51,47",
      "points": ""
    },
    {
      "street": "Điện Biên Phủ",
      "ward": "Mỹ Long",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.380648-105.445943",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Thoại Ngọc Hầu",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.373607-105.448692",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Trần Khánh Dư",
      "ward": "Mỹ Xuyên",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.376893-105.434516",
      "radius": "35,10",
      "points": ""
    },
    {
      "street": "Nguyễn Tri Phương",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.391791-105.424013",
      "radius": "24,02",
      "points": ""
    },
    {
      "street": "Trần Nhật Duật",
      "ward": "Mỹ Long",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.379127-105.442222",
      "radius": "46,45",
      "points": ""
    },
    {
      "street": "Thoại Ngọc Hầu",
      "ward": "Mỹ Long",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.380186-105.444343",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Phạm Ngọc Thạch",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "25,24",
      "points": ""
    },
    {
      "street": "Hẻm Phan Bội Châu",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "21,90",
      "points": ""
    },
    {
      "street": "Cặp Rạch Cái Sơn",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "18,57",
      "points": ""
    },
    {
      "street": "Lý Thái Tổ Nối Dài",
      "ward": "Mỹ Xuyên",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "14,91",
      "points": ""
    },
    {
      "street": "Lạc Long Quân",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.394579-105.415538",
      "radius": "16,84",
      "points": ""
    },
    {
      "street": "Lý Thái Tổ",
      "ward": "Mỹ Xuyên",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.374324-105.438700",
      "radius": "68,18",
      "points": ""
    },
    {
      "street": "Lương Định Của",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "26,79",
      "points": ""
    },
    {
      "street": "Võ Văn Hoài",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.388538-105.420879",
      "radius": "22,15",
      "points": ""
    },
    {
      "street": "Gần bệnh viện Hạnh Phúc",
      "ward": "Mỹ Thới",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "18,79",
      "points": ""
    },
    {
      "street": "Trần Quang Diệu",
      "ward": "Mỹ Xuyên",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.378991-105.436415",
      "radius": "74,50",
      "points": ""
    },
    {
      "street": "Ngô Thời Sĩ",
      "ward": "Mỹ Quý",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.361450-105.437446",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Gần bến xe Long Xuyên",
      "ward": "Mỹ Quý",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "4,52",
      "points": ""
    },
    {
      "street": "Đào Duy Từ",
      "ward": "Mỹ Quý",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.364280-105.448851",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Hẻm rạch Ba Đá",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "13,54",
      "points": ""
    },
    {
      "street": "Đường kênh cây lựu",
      "ward": "Mỹ Quý",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Mỹ Khánh",
      "ward": "Mỹ Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "5,50",
      "points": ""
    },
    {
      "street": "Lê Trọng Tấn",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.365971-105.428330",
      "radius": "39,13",
      "points": ""
    },
    {
      "street": "Nguyễn Nhạc",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.391715-105.419824",
      "radius": "20,26",
      "points": ""
    },
    {
      "street": "Phạm Cự Lượng nối liền",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "4,27",
      "points": ""
    },
    {
      "street": "Nguyễn Hoàng",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.383052-105.425821",
      "radius": "27,50",
      "points": ""
    },
    {
      "street": "Bùi Văn Danh",
      "ward": "Mỹ Xuyên",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.379918-105.434456",
      "radius": "11,42",
      "points": ""
    },
    {
      "street": "Đường số 5",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "31,43",
      "points": ""
    },
    {
      "street": "cặp gạch gòi lớn",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "9,58",
      "points": ""
    },
    {
      "street": "Đường Mai Xuân Hưởng",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "12,00",
      "points": ""
    },
    {
      "street": "Đường số 12",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.391924-105.414587",
      "radius": "16,67",
      "points": ""
    },
    {
      "street": "Đường số 6",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "5,61",
      "points": ""
    },
    {
      "street": "Cặp rạch Tầm Bót",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.367442-105.436059",
      "radius": "12,00",
      "points": ""
    },
    {
      "street": "Hẻm 7",
      "ward": "Mỹ Xuyên",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.376668-105.439349",
      "radius": "36,89",
      "points": ""
    },
    {
      "street": "Đường số 7",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Quốc lộ 91 đường Trần Hưng Đạo",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "F9-01",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "23,00",
      "points": ""
    },
    {
      "street": "Đường số 17",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "16,32",
      "points": ""
    },
    {
      "street": "Khu văn phòng Mỹ Quí",
      "ward": "Mỹ Quý",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "7,60",
      "points": ""
    },
    {
      "street": "Mặt tiền quốc lộ 91",
      "ward": "Mỹ Thạnh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "17,15",
      "points": ""
    },
    {
      "street": "Đường cặp rạch Cái Dung",
      "ward": "Mỹ Thạnh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.322286-105.457519",
      "radius": "8,95",
      "points": ""
    },
    {
      "street": "Sư vạn hạnh",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.397113-105.414667",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "L3",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "30,00",
      "points": ""
    },
    {
      "street": "Hẻm Nguyễn Thái Học",
      "ward": "Mỹ Bình",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "35,00",
      "points": ""
    },
    {
      "street": "Đường số 1",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "11,39",
      "points": ""
    },
    {
      "street": "Hẻm đường liên khóm Tân Phú",
      "ward": "Mỹ Quý",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "\b-",
      "radius": "11,67",
      "points": ""
    },
    {
      "street": "Hẻm Huỳnh Thanh",
      "ward": "Mỹ Bình",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.386223-105.433526",
      "radius": "34,83",
      "points": ""
    },
    {
      "street": "Hẻm Cầu Đoàn Kết đường Vịt Huê Ký",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "18,56",
      "points": ""
    },
    {
      "street": "Hẻm đường nhà nghỉ Đồng Hồ",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "13,64",
      "points": ""
    },
    {
      "street": "Đường nhà hàng Tường Vy",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Hẻm Lê Văn Nhung",
      "ward": "Mỹ Bình",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "15,66",
      "points": ""
    },
    {
      "street": "Hẻm Quản Cơ Thành",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "17,93",
      "points": ""
    },
    {
      "street": "Nguyễn Khuyến",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.395664-105.428141",
      "radius": "13,00",
      "points": ""
    },
    {
      "street": "Kim Đồng",
      "ward": "Mỹ Long",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.381730-105.446825",
      "radius": "65,00",
      "points": ""
    },
    {
      "street": "Dương Viên Khuê",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "14,48",
      "points": ""
    },
    {
      "street": "Thành Thái",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.392440-105.422508",
      "radius": "54,69",
      "points": ""
    },
    {
      "street": "Cầu Trà Ôn",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "15,20",
      "points": ""
    },
    {
      "street": "Ngay chợ Trà Ôn",
      "ward": "Bình Đức",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "16,68",
      "points": ""
    },
    {
      "street": "Đường số 4",
      "ward": "Mỹ Thạnh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "5,65",
      "points": ""
    },
    {
      "street": "Hẻm gần Ủy ban Mỹ Hòa",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "6,25",
      "points": ""
    },
    {
      "street": "Đông Thịnh 5",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "10,50",
      "points": ""
    },
    {
      "street": "Hẻm Mỹ Phước",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "20,00",
      "points": ""
    },
    {
      "street": "Hẻm kinh đào tám cẩu",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "-",
      "radius": "21,45",
      "points": ""
    },
    {
      "street": "DF9",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Lý Bôn",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "18,68",
      "points": ""
    },
    {
      "street": "Hẻm 8 Kỳ",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "11,12",
      "points": ""
    },
    {
      "street": "Hẻm Trần Hưng đạo",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "12,62",
      "points": ""
    },
    {
      "street": "Đường cặp rạch tầm bót",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Nguyễn Thái Học",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.382398-105.427720",
      "radius": "39,00",
      "points": ""
    },
    {
      "street": "Đường cặp rạch gòi lớn 3",
      "ward": "Mỹ Thới",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "5,45",
      "points": ""
    },
    {
      "street": "Hẻm Lý Văn Phức",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Dự Định",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "22,15",
      "points": ""
    },
    {
      "street": "Trần Quang Khải",
      "ward": "Mỹ Thới",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.347157-105.459617",
      "radius": "21,88",
      "points": ""
    },
    {
      "street": "Tuyến N4",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "43,86",
      "points": ""
    },
    {
      "street": "đường vành đai trong",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "5,84",
      "points": ""
    },
    {
      "street": "Nguyễn Bỉnh Khiêm",
      "ward": "Mỹ Long",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Đường quán Công Tử Bạc Liêu",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Hẻm cặp rạch Ông Mạnh",
      "ward": "Đông Xuyên",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "15,40",
      "points": ""
    },
    {
      "street": "Lê Chân",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "32,41",
      "points": ""
    },
    {
      "street": "D5",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "21,00",
      "points": ""
    },
    {
      "street": "N4",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "20,18",
      "points": ""
    },
    {
      "street": "Hùng Vương",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.376633-105.443822",
      "radius": "80,56",
      "points": ""
    },
    {
      "street": "HẺM 8 KỲ",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "11,12",
      "points": ""
    },
    {
      "street": "khu trại cá giống",
      "ward": "Mỹ Quý",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "25,00",
      "points": ""
    },
    {
      "street": "Đường 25",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "25,83",
      "points": ""
    },
    {
      "street": "Đường số 2",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "17,93",
      "points": ""
    },
    {
      "street": "Mương Thầy Phó",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "0,29",
      "points": ""
    },
    {
      "street": "Phan Bội Châu,",
      "ward": "Bình Khánh",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.39877372292972-105.4280899551382",
      "radius": "20,97",
      "points": ""
    },
    {
      "street": "Thoại Ngọc Hầu",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "13,39",
      "points": ""
    },
    {
      "street": "ngã 4 lộ thông 4 mặt đất mỹ hòa",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Đường số 4C",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "20,00",
      "points": ""
    },
    {
      "street": "đường cặp vịt huê ký",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Hẻm Châu Thị Tế",
      "ward": "Mỹ Long",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "17,90",
      "points": ""
    },
    {
      "street": "Hẻm Nguyễn Du",
      "ward": "Mỹ Bình",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "26,11",
      "points": ""
    },
    {
      "street": "dân cư Tỉnh Đoàn",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Đường cặp rạch Bằng Lăng",
      "ward": "Mỹ Hòa",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Khu dân cư AB",
      "ward": "",
      "type": "poly",
      "color": "#FFFF00",
      "latlong": "",
      "radius": "0,00",
      "points": "10.36189-105.42752;10.36255-105.42913;10.36433-105.42964;10.36188-105.43169;10.36206-105.43129;10.36027-105.42941"
    },
    {
      "street": "Diamond City",
      "ward": "",
      "type": "poly",
      "color": "#FFFF00",
      "latlong": "",
      "radius": "0,00",
      "points": "10.371348347700836-105.45154300829883;10.366704753796942-105.4547616591167;10.367591263405748-105.45565215250964;10.372836393903563-105.45377460619922"
    },
    {
      "street": "Golden City An Giang",
      "ward": "",
      "type": "poly",
      "color": "#FFFF00",
      "latlong": "",
      "radius": "0,00",
      "points": "10.384307065699762-105.41755800789349;10.377257510681115-105.42163496559613;10.37860833592401-105.42584066933148;10.378861615007729-105.42648439949505;10.38211201171141-105.42622690742962;10.387979525411527-105.42335157936566"
    },
    {
      "street": "Ung Văn Khiêm",
      "ward": "Mỹ Phước",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.374889580125526-105.4321539402008",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Lê Văn Nhung",
      "ward": "Mỹ Bình",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.385474782803735-105.43128959547329",
      "radius": "0,00",
      "points": ""
    },
    {
      "street": "Lê Thị Nhiên",
      "ward": "Mỹ Long",
      "type": "circle",
      "color": "#FF0000",
      "latlong": "10.384745280497278-105.44147145300903",
      "radius": "0,00",
      "points": ""
    }
  ];
  
  export default data;